import { AppRegistry } from '@uxanalytics/registry';
import { AppContextFactory } from '@uxanalytics/core';
import { entries } from 'lodash';
import * as core from '@uxanalytics/core';
import * as clients from '@contentsquare/uxanalytics-client';
import * as constants from '@contentsquare/business-constants';
import * as lazy from '@uxanalytics/lazy-web-component';

import '@cs-materials/common';
import { defineCustomElements as defineCommonCustomElements } from '@cs-materials/common/loader';

export type ModuleName = '@uxanalytics/app-goals' | '@angular9' | string;

function deferred() {
  let done;
  const promise = new Promise(res => {
    done = res;
  });
  return {
    done,
    promise,
  };
}

export class MicroApps {
  private static installation = deferred();

  static async install() {
    await this.setupAppRegistry();
    await this.installStencilLibraries();
    await this.installMicroFrontends();
    console.log('Apps installed');
    (this.installation.done as any)();
  }

  static import(moduleName: ModuleName[] | ModuleName) {
    return this.installation.promise.then(() => AppRegistry.import(moduleName));
  }

  private static setupAppRegistry() {
    (window as any).AppRegistry = AppRegistry;
    AppRegistry.set('@uxanalytics/core', core);
    AppRegistry.set('@contentsquare/uxanalytics-client', clients);
    AppRegistry.set('@contentsquare/business-constants', constants);
    AppRegistry.set('@uxanalytics/lazy-web-component', lazy);
  }

  private static installStencilLibraries() {
    defineCommonCustomElements(window);
  }

  private static async installMicroFrontends() {
    const apps = this.getApps();
    await AppRegistry.install(apps);
  }

  private static getApps() {
    const { config } = AppContextFactory.get();

    const prodDomainName = 'https://frontends.contentsquare.com';
    const branchDomainName = 'https://frontends-dev.contentsquare.com';
    console.log(config.microFrontends);

    const apps = entries(config.microFrontends || {})
      .filter(([appName]: any) => appName !== 'null')
      .map(([appName, versionOrUrl]: any) => {
        if (/^(https?:|\/)/.test(versionOrUrl)) {
          return versionOrUrl;
        }
        const domainName = /^branch-/.test(versionOrUrl) ? branchDomainName : prodDomainName;
        return `${domainName}/${appName}/${versionOrUrl}/remote-entry.js`;
      });

    return apps;
  }
}
